import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["option", "input", "border"]

	select(event) {
		// Get the clicked option's value
		const selectedValue = event.currentTarget.dataset.value

		// Update all radio buttons
		this.inputTargets.forEach(input => {
			input.checked = input.value === selectedValue
		})

		// Update visual styling
		this.updateVisualState()
	}

	connect() {
		// Set initial visual state based on checked radio button
		this.updateVisualState()
	}

	updateVisualState() {
		this.optionTargets.forEach((option, index) => {
			const input = this.inputTargets[index]
			const border = this.borderTargets[index]

			if (input.checked) {
				// Selected state
				option.classList.add('bg-emerald-50', 'border-emerald-300')
				option.classList.remove('border-gray-200')
				border.classList.add('border-emerald-500')
				border.classList.remove('border-transparent')
			} else {
				// Unselected state
				option.classList.remove('bg-emerald-50', 'border-emerald-300')
				option.classList.add('border-gray-200')
				border.classList.remove('border-emerald-500')
				border.classList.add('border-transparent')
			}
		})
	}
}
